import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'spv2-privacy-statement',
    templateUrl: './privacy-statement.component.html',
    styleUrls: ['./privacy-statement.component.scss'],
    standalone: false
})
export class PrivacyStatementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  scrollTo(event: Event, el: HTMLElement) {
    event.preventDefault();
    el.scrollIntoView();
  }
}
